import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './teamsTabSetup.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { teamsTabConfiguration, TeamsTabWidgetName } from "../teamTypes";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import topic from 'dojo/topic';

class teamsTabSetup extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private configDlg:MdsLax<InstanceType<typeof GenericDialog>>;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onClick_Calendar(ev:Event){
        this.setState('calendar');
    }
    private _onClick_ProjectCalendar(ev:Event){
        this.setState('projectCalendarSetup');
    }

    private async setState(state:TeamsTabWidgetName){
        let commitState = false;
        switch (state){
            // hier koennen evtl. andere einstellunges moeglichkeiten eingeblendet werden, falls gewuenscht
            case 'calendar':
                localStorage.removeItem("ego_CalendarSettings");
                await window.msTeamsSimpleApi.helperFn.stateSet("ego_CalendarSettings", "");
                commitState = true; //wir haben keine weitere settings hier, wir koennen sofort neu-laden
                break;
            case 'projectCalendarSetup':
                commitState = true; //settings kommen aus pit
                break;
        }
        if (commitState){
            window.msTeamsSimpleApi.onIsTeams(lang.hitch(this, async () => {
                await window.msTeamsSimpleApi.helperFn.stateSet("system_tabConfiguration", JSON.stringify({
                    teamsTabWidgetName: state
                } as teamsTabConfiguration));
                try {
                    (window.location.reload as (forcedReload?: boolean) => void)(true);
                } catch {
                    window.location.reload();
                }
            }));
        }
    }

    public async showAsDlg(){
        topic.publish("MsTeamsIntegration/ToggleTabSettingsButton", false);
        this.configDlg = new GenericDialog();
        this.configDlg.show(
            this,
            this.getTranslation("General_Settings"),
            null,
            null,
            'close',
            lang.hitch(this, ()=>{
                topic.publish("MsTeamsIntegration/ToggleTabSettingsButton", true);
            })
        );
    }
}

export default mdsWidget(teamsTabSetup);
